export default __webpack_public_path__ + "static/media/Snd_NowYouTry.fbdfa000.mp3";